export const MESSAGE_TYPE_FAIL = 'fail';
export const MESSAGE_TYPE_SUCCESS = 'success';
